import React, { Component } from 'react';

import { Row, Col, InputGroup } from 'react-bootstrap';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
/**
import CommonRadio from '../components/CommonRadio';
import CommonCheckbox from '../components/CommonCheckbox';
*/
import CommonButton from '../components/CommonButton';
class SearchMasterDataPosition extends Component {

    render = () => {
        let props = this.props;

        let { onInputChange, onSearch } = props;

        let { Action, Searchs, InputGroup: InputGroups, Operation } = props;

        let { name, status } = Searchs;

        if(Operation.Search !== true) return null;

        return (
            <>
                <Row className="ms-2 me-2">
                    <Col md={12} className="custom-search-panel-body">               
                        <Row className="mt-3">
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{name.label}</InputGroup.Text>
                                    <CommonInput
                                        element="Searchs"
                                        input={name}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{status.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={status}
                                        option={{source: 'options', section: 'status', item: 'default'}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>
                            <Col md={3}>
                                <CommonButton 
                                    task="search" 
                                    disabled={Action.Loading.search ? true : false}
                                    callback={(e) => onSearch(e)} 
                                />
                            </Col>
                            <Col md={3}></Col>
                        </Row>
                    </Col>
                </Row>
            </>
        )
    }
}

export default SearchMasterDataPosition;